import { Utensils, Truck, Clock, MapPin, Phone, Mail } from "lucide-react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="py-14 md:py-16 px-4 bg-snowbg">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-redtxt text-2xl md:text-4xl font-bold mb-4 text-center">About Our Canteen</h2>
          <h3 className="text-lightGray text-base md:text-lg font-semibold max-w-2xl mx-auto">
            Welcome to the <span className="font-bold">GrabGrub</span> –
            your one-stop spot for fresh and tasty meals.<br />
            Order online and pick up your food without the wait.<br />
            Quick, simple, and always delicious!
          </h3>
        </motion.div>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          whileHover={{ y: -5 }}
          className="grid md:grid-cols-3 gap-8 max-w-6xl w-full mb-16"
        >
          <div className="flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
            <Utensils className="w-8 h-8 text-redtxt mb-4" />
            <h2 className="text-base md:text-lg font-bold text-darktxt mb-2">
              Fresh Meals
            </h2>
            <p className="text-darktxt text-sm md:text-base mb-2">
              Enjoy hygienic and freshly prepared meals daily at our canteen.
            </p>
          </div>

          <div className="flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
            <Truck className="w-8 h-8 text-redtxt mb-4" />
            <h2 className="text-base md:text-lg font-bold text-darktxt mb-2">
              Quick Takeaway
            </h2>
            <p className="text-darktxt text-sm md:text-base mb-2]">
              Place your order online and pick it up right on time – no queues!
            </p>
          </div>


          <div className="flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
            <Clock className="w-8 h-8 text-redtxt mb-4" />
            <h2 className="text-base md:text-lg font-bold text-darktxt mb-2">
              Convenient Hours
            </h2>
            <p className="text-darktxt text-sm md:text-base mb-2">
              Serving students and staff from early morning till late evening.
            </p>
          </div>
        </motion.div>

        {/* Location & Address Section */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          whileHover={{ y: -5 }}
          className="grid md:grid-cols-2 gap-8 max-w-6xl w-full bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden"
        >
          {/* Map */}
          <div className="rounded-xl overflow-hidden shadow-md">
            <iframe
              title="Canteen Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.072640241841!2d73.0763966!3d22.4674907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fb5c35fbabdad%3A0x5cb5c90f2aebca10!2sFee%20fa%20foo!5e0!3m2!1sen!2sin!4v1695467890000!5m2!1sen!2sin&z=18"
              width="100%"
              height="350"
              allowFullScreen=""
              loading="lazy"
              className="border-0 w-full h-[350px]"
            ></iframe>
          </div>

          {/* Address */}
          <div className="flex flex-col justify-center p-4">
            <h2 className="text-2xl font-semibold text-darktxt flex items-center mb-4">
              <MapPin className="w-6 h-6 text-darktxt mr-2" />
              Canteen Address
            </h2>
            <p className="text-darktxt text-sm md:text-base mb-6">
              Sardar Vallabhbhai Patel Institute of Technology <br />
              Vasad, Gujarat 388306
            </p>

            <div className="flex items-center mb-3">
              <Phone className="w-5 h-5 text-darktxt mr-2" />
              <span className="text-darktxt text-sm md:text-base">+91 98989 00001</span>
            </div>

            <div className="flex items-center">
              <Mail className="w-5 h-5 text-darktxt mr-2" />
              <span className="text-darktxt text-sm md:text-base">grabgrubcontact@gmail.com</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section >
  );
};

export default About;